/// <amd-module name="Build/Admin/Agent/Flux" />
import { IVssPageContext } from "VSS/Platform/Context";

import { ActionsHub } from "Build/Admin/Agent/Actions/ActionsHub";
import { AgentActionCreator } from "Build/Admin/Agent/Actions/AgentActionCreator";
import { AgentSource } from "Build/Admin/Agent/Sources/AgentSource";
import { StoresHub } from "Build/Admin/Agent/Stores/StoresHub";
import { JobSource } from "Build/Admin/Common/Sources/JobSource";

export class Flux {
    public actionsHub: ActionsHub;
    public agentActionCreator: AgentActionCreator;
    public agentSource: AgentSource;
    public jobSource: JobSource;
    public storesHub: StoresHub;

    public constructor(pageContext: IVssPageContext) {
        this.actionsHub = new ActionsHub();
        this.agentSource = new AgentSource(pageContext);
        this.jobSource = new JobSource(pageContext);
        this.storesHub = new StoresHub(this.actionsHub);
        this.agentActionCreator = new AgentActionCreator({
            actionsHub: this.actionsHub,
            agentSource: this.agentSource,
            jobSource: this.jobSource,
            pageContext: pageContext,
            storesHub: this.storesHub
        });
    }

    public dispose(): void {
        this.agentActionCreator.dispose();
    }
}
